import axios from "axios";
import { APIHOST } from "@/config";
const apihost = APIHOST[process.env.NODE_ENV];
axios.defaults.baseURL = apihost;
async function signin(password) {
    const response = await axios.post("/auth/signin", {
        password,
    });
    return response.data.auth;
}
export default {
    signin,
};
